import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom'
import i18n from 'i18n-react';
import es from './languages/es.json';
import cat from './languages/cat.json';
import Home from './pages/Home.js';
import './App.css';
class App extends React.Component {
  componentWillMount() {
    i18n.setTexts({
      'es': es,
      'cat': cat
    });
  }

  render() {
    return (
      <main>
        <BrowserRouter>
          <div>
            <Route exact path='/' component={withProps(Home, {locale: 'es'})}/>
            <Route path='/es' component={withProps(Home, {locale: 'es'})}/>
            <Route path='/cat' component={withProps(Home, {locale: 'cat'})}/>
          </div>
        </BrowserRouter>
      </main>
    );
  }
}
function withProps(Component, props) {
  return function(matchProps) {
    return <Component {...props} {...matchProps} />
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js